import React from "react";
import "./loader.css";

const LoaderSpinner = ({ type, className }) => (
  <span type={type} className={`flex justify-center items-center h-12 w-12 ${className || ""}`}>
    {type === "square" && (
      <div className={`loader-${type}`}>
        <div className={`${type}-inner`} />
      </div>
    )}
    {type === "circle" && <div className={`loader-${type} `} />}
  </span>
);

LoaderSpinner.defaultProps = {
  type: "square"
};

export default LoaderSpinner;
